import * as Cookie from './cookie';

// Rewrite to class
export default function initTabs() {
    window.addEventListener('DOMContentLoaded', () => {
        const tabHolders = document.querySelectorAll('[data-tabs]');

        tabHolders.forEach((tabHolder) => {
            const tabLinks = tabHolder.querySelectorAll('[data-show-tab]');
            const tabContents = tabHolder.querySelectorAll('[data-content-tab]');

            function unselectLinks() {
                tabLinks.forEach((tabLink) => {
                    tabLink.setAttribute('aria-selected', 'false');
                });
            }

            function selectLink(link) {
                link.setAttribute('aria-selected', 'true');
            }

            function hideTabs() {
                tabContents.forEach((tabContent) => {
                    tabContent.setAttribute('aria-hidden', 'true');
                });
            }

            function showTab(tab, focus = false) {
                tab.setAttribute('aria-hidden', 'false');

                if (focus && tab.querySelectorAll('[focusable]')[0]) {
                    tab.querySelectorAll('[focusable]')[0].focus();
                }
            }

            tabLinks.forEach((elem) => {
                elem.addEventListener('click', (e) => {
                    e.preventDefault();

                    unselectLinks();
                    hideTabs();

                    selectLink(e.currentTarget);
                    showTab(tabHolder.querySelector(`[data-content-tab="${elem.getAttribute('data-show-tab')}"]`), true);
                });

                elem.addEventListener('keydown', (e) => {
                    const maxIndex = tabHolder.querySelector('nav').children.length - 1;
                    const currentIndex = Array.from(tabHolder.querySelector('nav').children).indexOf(e.currentTarget);
                    let nextIndex = -1;

                    if (e.key === 'Tab') {
                        tabHolder.querySelectorAll(`[data-content-tab="${e.currentTarget.getAttribute('data-show-tab')}"] [focusable]`)[0].focus();
                    }

                    if (e.keyCode === 37) { // Left arrow
                        nextIndex = (currentIndex === 0) ? maxIndex : currentIndex - 1;
                    }

                    if (e.keyCode === 39) { // Right arrow
                        nextIndex = (currentIndex === maxIndex) ? 0 : currentIndex + 1;
                    }

                    if (nextIndex > -1) {
                        const nextTab = tabHolder.querySelector('nav').children[nextIndex];

                        e.preventDefault();

                        unselectLinks();
                        hideTabs();

                        selectLink(nextTab);
                        showTab(tabHolder.querySelector(`[data-content-tab="${nextTab.getAttribute('data-show-tab')}"]`), false);
                        nextTab.focus();
                    }
                });
            });

            // Select from location hash or first
            const selectedMunicipality = Cookie.get('municipality');
            let dataShowTab;
            let dataContentTab;

            if (selectedMunicipality !== 'none') {
                dataShowTab = tabHolder.querySelector(`[data-show-tab="${selectedMunicipality}"]`);
                dataContentTab = tabHolder.querySelector(`[data-content-tab="${selectedMunicipality}"]`);
            } else if (window.location.hash) {
                const hashId = window.location.hash.substring(1);
                dataShowTab = tabHolder.querySelector(`[data-show-tab="${hashId}"]`);
                dataContentTab = tabHolder.querySelector(`[data-content-tab="${hashId}"]`);
            }

            if (dataShowTab) {
                selectLink(dataShowTab);
                showTab(dataContentTab);
            } else {
                selectLink(tabLinks[0]);
                showTab(tabContents[0]);
            }
        });
    });
}
